import Cased from '@/components/ui/Cased'
import CopyButton from './CopyButton'

const channels = [
  {
    id: 'npm',
    title: 'npm: missiondesign',
    text: 'The stylesheets, self-hosted typefaces, agency themes, seals and the same JSON data, versioned with the system.',
    code: `npm install missiondesign

/* In your CSS entry point */
@import 'missiondesign/mds.css';`,
    copy: 'Copy install',
    href: 'https://www.npmjs.com/package/missiondesign',
  },
  {
    id: 'react',
    title: 'React: missiondesign-react',
    text: 'The banner, identifier, lockup, agency marks, mission picker, theme toggle and dialog, wired to the same preferences the site uses.',
    code: `npm install missiondesign missiondesign-react

import { PrefsProvider, Banner, Lockup } from 'missiondesign-react'

<PrefsProvider>
  <Banner />
  <Lockup />
</PrefsProvider>`,
    copy: 'Copy example',
    href: 'https://www.npmjs.com/package/missiondesign-react',
  },
  {
    id: 'api',
    title: 'Static API',
    text: 'Every token, theme, component, pattern and rule as JSON and CSS at stable URLs, open to a plain GET from any language or agent.',
    code: `curl https://missiondesign.us/mds/manifest.json
curl https://missiondesign.us/mds/themes/usda.json
curl https://missiondesign.us/mds/components.json`,
    copy: 'Copy requests',
  },
  {
    id: 'llms',
    title: 'llms.txt',
    text: 'A plain-text index at the site root that tells language models where the guidance and the machine files live, and the whole reference in one file beside it.',
    code: `curl https://missiondesign.us/llms.txt
curl https://missiondesign.us/llms-full.txt`,
    copy: 'Copy request',
  },
]

/** The ways to take MDS into a project, each with a copyable example. */
export default function Channels() {
  return (
    <section className="doc-section" aria-labelledby="channels-title">
      <h2 id="channels-title"><Cased>Use MDS your way</Cased></h2>
      <p>One set of definitions, published four ways. Pick the one that fits the tool doing the work.</p>
      <div className="doc-grid doc-channels">
        {channels.map((channel) => (
          <article key={channel.id} className="mds-card mds-card--outline doc-channel">
            <h3 className="mds-card__title"><Cased>{channel.title}</Cased></h3>
            <p className="mds-muted">{channel.text}</p>
            <pre className="mds-code doc-channel__code" tabIndex={0} aria-label={`${channel.title} example`}>
              <code>{channel.code}</code>
            </pre>
            <CopyButton text={channel.code} label={channel.copy} />
            {'href' in channel && (
              <a className="mds-link" href={channel.href}>
                {channel.title.replace(/^.*: /, '')} on npm
              </a>
            )}
          </article>
        ))}
      </div>
    </section>
  )
}
